export default {
  'global.checkAll': 'Alles selecteren',
  'global.clearAll': 'Alles wissen',
  'global.empty': 'Het lijkt erop dat er hier niets is!',
  'sort.asc': 'Oplopend sorteren',
  'sort.desc': 'Aflopend sorteren',
};
